(function () {
  const sectionSelector = '.section-college-article-template'
  const initializedAttribute = 'data-college-article-template-initialized'
  const learningApiBase = 'https://informationcollection.benyuan1.com/api/trendFavorite'

  const normaliseLearningResult = function (result) {
    return result && result.data && typeof result.data === 'object' && Object.prototype.hasOwnProperty.call(result.data, 'success')
      ? result.data
      : result
  }

  const learningRequestSucceeded = function (result) {
    const apiResult = normaliseLearningResult(result)
    return apiResult && (apiResult.success === true || result.status === 'success')
  }

  const setLearningProgress = function (progress, status) {
    if (!progress) return
    const complete = Number(status) === 1
    const unlogged = status === 'none'
    const initial = status === 'initial'
    const pending = !complete && !unlogged && !initial
    const label = progress.querySelector('[data-college-learning-label]')
    progress.hidden = false
    progress.disabled = false
    progress.classList.toggle('is-complete', complete)
    progress.classList.toggle('is-pending', pending)
    progress.classList.toggle('is-unlogged', unlogged)
    progress.classList.toggle('is-initial', initial)
    progress.setAttribute('aria-disabled', String(pending))
    progress.tabIndex = pending ? -1 : 0
    if (label) label.textContent = complete ? 'Nailed It!' : ((unlogged || initial) ? '' : 'Polish Up')
  }

  const updateLearningStatus = function (customerId, customerName, customerEmail, trendId, title, learnStatus) {
    return fetch(`${learningApiBase}/updateLearnStatus`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        user_id: customerId,
        user_name: customerName,
        email: customerEmail,
        trend_id: trendId,
        title,
        learn_status: learnStatus
      })
    }).then(function (response) {
      if (!response.ok) throw new Error('Update learning status request failed')
      return response.json()
    })
  }

  const markLearningComplete = function (customerId, customerName, customerEmail, trendId, category, title) {
    return fetch(`${learningApiBase}/favorite`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        user_id: customerId,
        user_name: customerName,
        email: customerEmail,
        trend_id: trendId,
        category,
        title,
        type: 2,
        learn_status: 1
      })
    }).then(function (response) {
      if (!response.ok) throw new Error('Mark learning complete request failed')
      return response.json()
    })
  }

  const initLearningAuthPrompt = function (section) {
    const prompt = section.querySelector('[data-academy-learning-auth-prompt]')
    if (!prompt || prompt.dataset.ready === 'true') return
    prompt.dataset.ready = 'true'
    const close = function () {
      prompt.hidden = true
      prompt.setAttribute('aria-hidden', 'true')
      document.documentElement.classList.remove('academy-learning-auth-prompt-open')
    }
    prompt.querySelectorAll('[data-academy-learning-auth-prompt-close]').forEach(function (element) { element.addEventListener('click', close) })
    prompt.addEventListener('click', function (event) {
      if (event.target === prompt || event.target.closest('[data-academy-learning-auth-prompt-close]')) close()
    })
    prompt.querySelector('[data-academy-learning-auth-prompt-continue]')?.addEventListener('click', function () {
      close()
      section.__likeShareAuth?.setTab?.('login')
      section.__likeShareAuth?.openModal?.()
    })
    prompt.addEventListener('keydown', function (event) { if (event.key === 'Escape') close() })
  }

  const openLearningAuthPrompt = function (section) {
    const prompt = section.querySelector('[data-academy-learning-auth-prompt]')
    if (!prompt) return
    prompt.hidden = false
    prompt.setAttribute('aria-hidden', 'false')
    document.documentElement.classList.add('academy-learning-auth-prompt-open')
    prompt.querySelector('[data-academy-learning-auth-prompt-continue]')?.focus()
  }

  const initLearningCompletePrompt = function (section) {
    const prompt = section.querySelector('[data-academy-learning-complete-prompt]')
    if (!prompt || prompt.dataset.ready === 'true') return
    prompt.dataset.ready = 'true'
    const close = function () {
      prompt.hidden = true
      prompt.setAttribute('aria-hidden', 'true')
    }
    prompt.querySelectorAll('[data-academy-learning-complete-prompt-close]').forEach(function (element) { element.addEventListener('click', close) })
    prompt.addEventListener('click', function (event) {
      if (event.target === prompt || event.target.closest('.academy-learning-complete-prompt__backdrop')) close()
    })
    prompt.addEventListener('keydown', function (event) { if (event.key === 'Escape') close() })
  }

  const openLearningCompletePrompt = function (section) {
    const prompt = section.querySelector('[data-academy-learning-complete-prompt]')
    if (!prompt) return
    prompt.hidden = false
    prompt.setAttribute('aria-hidden', 'false')
    prompt.querySelector('[data-academy-learning-complete-prompt-close]')?.focus()
  }

  const bindCompletedProgressToggle = function (progress, customerId, customerName, customerEmail, trendId, title) {
    if (!progress || progress.dataset.completedProgressToggleReady === 'true') return
    progress.dataset.completedProgressToggleReady = 'true'
    progress.addEventListener('click', function () {
      if (!progress.classList.contains('is-complete') || progress.disabled) return
      progress.disabled = true
      updateLearningStatus(customerId, customerName, customerEmail, trendId, title, 0)
        .then(function (result) {
          if (learningRequestSucceeded(result)) setLearningProgress(progress, 0)
          else progress.disabled = false
        })
        .catch(function () { progress.disabled = false })
    })
  }

  const initLearningPendingPrompt = function (section) {
    const prompt = section.querySelector('[data-academy-learning-pending-prompt]')
    if (!prompt || prompt.dataset.ready === 'true') return
    prompt.dataset.ready = 'true'
    const close = function () {
      prompt.hidden = true
      prompt.setAttribute('aria-hidden', 'true')
      prompt.__confirmPendingLearning = null
    }
    prompt.querySelectorAll('[data-academy-learning-pending-prompt-close]').forEach(function (element) { element.addEventListener('click', close) })
    prompt.addEventListener('click', function (event) {
      if (event.target === prompt || event.target.closest('.academy-learning-pending-prompt__backdrop')) close()
    })
    prompt.querySelector('[data-academy-learning-pending-prompt-confirm]')?.addEventListener('click', close)
    prompt.addEventListener('keydown', function (event) { if (event.key === 'Escape') close() })
  }

  const openLearningPendingPrompt = function (section) {
    const prompt = section.querySelector('[data-academy-learning-pending-prompt]')
    if (!prompt) return
    prompt.hidden = false
    prompt.setAttribute('aria-hidden', 'false')
    prompt.querySelector('[data-academy-learning-pending-prompt-confirm]')?.focus()
  }

  const bindMarkLearned = function (block, customerId, customerName, customerEmail, metas, section) {
    const button = block?.querySelector('[data-college-mark-learned-button]')
    const trendId = block?.dataset.trendId
    const title = block?.dataset.trendTitle
    const category = block?.dataset.trendCategory
    if (!button || !trendId || !title || !category || button.dataset.markLearnedReady === 'true') return
    button.dataset.markLearnedReady = 'true'
    button.addEventListener('click', function () {
      if (button.disabled) return
      button.disabled = true
      markLearningComplete(customerId, customerName, customerEmail, trendId, category, title)
        .then(function (result) {
          if (!learningRequestSucceeded(result)) {
            button.disabled = false
            return
          }
          metas.forEach(function (meta) {
            if (String(meta.dataset.trendId) === String(trendId)) setLearningProgress(meta.querySelector('[data-college-learning-progress]'), 1)
          })
          openLearningCompletePrompt(section)
          button.disabled = true
          button.setAttribute('aria-label', 'This tutorial is learned')
        })
        .catch(function () { button.disabled = false })
    })
  }

  const enableMarkLearnedAfterDelay = function (button) {
    if (!button || button.dataset.learningTimerStarted === 'true') return
    button.dataset.learningTimerStarted = 'true'
    button.disabled = false
    button.setAttribute('aria-label', 'Mark this tutorial as learned')

    // Temporarily disable the two-minute NAILED IT! delay.
    // window.setTimeout(function () {
    //   button.disabled = false
    //   button.setAttribute('aria-label', 'Mark this tutorial as learned')
    // }, 120000)
  }

  const bindInitialProgressStart = function (progress, customerId, customerName, customerEmail, trendId, title, section) {
    if (!progress || progress.dataset.initialProgressStartReady === 'true') return
    progress.dataset.initialProgressStartReady = 'true'
    progress.addEventListener('click', function () {
      if (!progress.classList.contains('is-initial') || progress.disabled) return
      progress.disabled = true
      setLearningProgress(progress, 0)
      openLearningPendingPrompt(section)
      updateLearningStatus(customerId, customerName, customerEmail, trendId, title, 0)
        .then(function (result) {
          if (!learningRequestSucceeded(result)) setLearningProgress(progress, 'initial')
        })
        .catch(function () { setLearningProgress(progress, 'initial') })
    })
  }

  const initLearningProgress = function (section) {
    const template = section.querySelector('[data-college-article-template]')
    if (!template) return
    const metas = template.querySelectorAll('[data-college-learning-meta]')
    const markLearnedBlocks = template.querySelectorAll('[data-college-mark-learned]')
    const customerId = template.dataset.customerId
    const customerName = template.dataset.customerName
    const customerEmail = template.dataset.customerEmail
    if (!metas.length && !markLearnedBlocks.length) return
    initLearningCompletePrompt(section)
    initLearningPendingPrompt(section)
    if (template.dataset.customerLoggedIn !== 'true' || !customerId) {
      initLearningAuthPrompt(section)
      metas.forEach(function (meta) {
        const progress = meta.querySelector('[data-college-learning-progress]')
        setLearningProgress(progress, 'none')
      })
      markLearnedBlocks.forEach(function (block) {
        const button = block.querySelector('[data-college-mark-learned-button]')
        enableMarkLearnedAfterDelay(button)
        button?.addEventListener('click', function () { openLearningAuthPrompt(section) })
      })
      return
    }

    markLearnedBlocks.forEach(function (block) {
      enableMarkLearnedAfterDelay(block.querySelector('[data-college-mark-learned-button]'))
      bindMarkLearned(block, customerId, customerName, customerEmail, metas, section)
    })

    fetch(`${learningApiBase}/list`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ user_id: customerId, category: 'all', type: 2 })
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Learning progress request failed')
        return response.json()
      })
      .then(function (result) {
        const apiResult = normaliseLearningResult(result)
        if (!learningRequestSucceeded(result) || !Array.isArray(apiResult.data)) return
        const records = new Map(apiResult.data.map(function (item) {
          return [String(item.trend_id), item.learn_status]
        }))
        markLearnedBlocks.forEach(function (block) {
          const button = block.querySelector('[data-college-mark-learned-button]')
          const learned = Number(records.get(String(block.dataset.trendId))) === 1
          button.disabled = learned
          if (learned) button.setAttribute('aria-label', 'This tutorial is learned')
        })
        metas.forEach(function (meta) {
          const progress = meta.querySelector('[data-college-learning-progress]')
          const trendId = meta.dataset.trendId
          const title = meta.dataset.trendTitle
          if (records.has(String(trendId))) {
            const learnStatus = records.get(String(trendId))
            setLearningProgress(progress, learnStatus)
            if (Number(learnStatus) === 1) bindCompletedProgressToggle(progress, customerId, customerName, customerEmail, trendId, title)
          }
          else {
            setLearningProgress(progress, 'initial')
            progress.setAttribute('aria-label', 'Start learning this tutorial')
            bindInitialProgressStart(progress, customerId, customerName, customerEmail, trendId, title, section)
          }
        })
      })
      .catch(function () {
        // Leave the progress hint hidden when its latest state cannot be loaded.
      })
  }

  function init (section) {
    if (!section || section.hasAttribute(initializedAttribute)) return
    section.setAttribute(initializedAttribute, 'true')
    initLearningProgress(section)

    section.querySelectorAll('[data-cat-faq]').forEach(function (faq) {
      faq.addEventListener('toggle', function (event) {
        const openedItem = event.target
        if (!openedItem.open || !openedItem.matches('.cat-faq__item')) return

        faq.querySelectorAll('.cat-faq__item[open]').forEach(function (item) {
          if (item !== openedItem) item.removeAttribute('open')
        })
      }, true)
    })

    section.querySelectorAll('.cat-product-rec__more').forEach(function (button) {
      button.addEventListener('click', function () {
        const panel = button.closest('.cat-product-rec')
        const expanded = panel.classList.toggle('cat-product-rec--expanded')
        button.setAttribute('aria-expanded', String(expanded))
      })
    })

    section.querySelectorAll('.cat-product-rec__summary').forEach(function (summary) {
      summary.addEventListener('click', function (event) {
        if (!window.matchMedia('(max-width: 749px)').matches) return

        const details = summary.closest('.cat-product-rec__panel')
        const productRec = summary.closest('.cat-product-rec')
        if (!details || !productRec) return

        // On mobile, the minus control returns an expanded list to its initial
        // faded state instead of closing the whole recommendation component.
        event.preventDefault()
        details.open = true
        productRec.classList.remove('cat-product-rec--expanded')
        const moreButton = productRec.querySelector('.cat-product-rec__more')
        if (moreButton) moreButton.setAttribute('aria-expanded', 'false')
      })
    })

    const relocateProducts = function () {
      const mobile = window.matchMedia('(max-width: 749px)').matches
      section.querySelectorAll('[data-cat-mobile-insert-position]').forEach(function (product) {
        const marker = product._catMobileMarker || document.createComment('cat-product-rec-position')
        if (!product._catMobileMarker) {
          product._catMobileMarker = marker
          product.parentNode.insertBefore(marker, product)
        }

        if (!mobile) {
          if (marker.parentNode && product.previousSibling !== marker) marker.parentNode.insertBefore(product, marker.nextSibling)
          product.classList.remove('cat-product-rec--mobile-relocated')
          return
        }

        const blocks = section.querySelector('.college-article-template__blocks')
        if (!blocks) return
        const position = Math.max(0, parseInt(product.dataset.catMobileInsertPosition, 10) || 0)
        const contentBlocks = Array.from(blocks.children).filter(function (item) {
          return item !== product && item.classList.contains('cat-block')
        })
        const anchor = contentBlocks[position - 1]
        if (anchor) blocks.insertBefore(product, anchor.nextSibling)
        else blocks.insertBefore(product, blocks.firstChild)
        product.classList.add('cat-product-rec--mobile-relocated')
      })
    }

    relocateProducts()
    window.addEventListener('resize', relocateProducts)
  }

  function initAll (root) {
    if (root && root.matches && root.matches(sectionSelector)) init(root)
    if (root && root.querySelectorAll) root.querySelectorAll(sectionSelector).forEach(init)
  }

  initAll(document)
  document.addEventListener('click', function (event) {
    const progress = event.target instanceof Element ? event.target.closest('[data-college-learning-progress].is-unlogged') : null
    if (!progress) return
    const template = progress.closest('[data-college-article-template]')
    const section = template?.closest('.section-college-article-template') || template?.closest('.shopify-section')
    if (!section) return
    event.preventDefault()
    initLearningAuthPrompt(section)
    openLearningAuthPrompt(section)
  })
  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target)
  })
})()
